import { PropsWithChildren, useEffect, useState } from 'react';

const STORAGE_KEY = 'theme';

export function ThemeProvider({ children }: PropsWithChildren) {
  const [theme, setTheme] = useState<string | null>(null);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const next = stored || 'light';
    setTheme(next);
    document.documentElement.classList.toggle('dark', next === 'dark');
  }, []);

  useEffect(() => {
    if (!theme) return;
    localStorage.setItem(STORAGE_KEY, theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return <>{children}</>;
}
